/**
 * Created by danielg on 1/6/19.
 * This is the button in the input area for sending a file to the consumer
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');


    var FileSharingViewController = ViewController.extend({
        ControllerName: 'FileSharingViewController',

        LPViewMap: {
            WRAPPER: '.lpview_file_sharing_input',
            DIALOG_PLACEHOLDER: '.lpview_file_preview',
            BUTTON: '.lpview_file_sharing_button',
            INPUT_PREFIX: 'LPAgentfileUpload_'
        },

        initialize : function (constructorData) {
            this.visitorId = constructorData.visitorId;
            this.chatId = constructorData.chatId;
            this.initView();
        },

        events: function () {
            this.viewEventsHandler.bindEvent({appName : this.visitorId, callback : this.showError, UIEvent : this.viewEventsHandler.eventType.SHOW_FILE_UPLOAD_ERROR});
            _bindChatEvents.call(this);
        },

        render: function () {
            _updateFileInput.call(this);
        }
    });

    FileSharingViewController.prototype.updateChatId = function(chatId) {
        if (chatId && chatId !== this.chatId) {
            if (this.chatId) {
                _unbindChatEvents.call(this);
            }
            this.chatId = chatId;
            _bindChatEvents.call(this);
        }
    };

    FileSharingViewController.prototype.initView = function () {

        var template = require('web-agent-templates/LP_file_sharing.html');
        template = this.injectTextDefaults(template,{visitorId: this.visitorId});
        this.createView({template: template});
        this.visible = false;

    };

    FileSharingViewController.prototype.showError = function (data) {
        var errorContent = _getErrorContent.call(this, data);
        if (errorContent) {
            var notifierLE = agentLEManager.notifierLE();
            var callback = function () {
                if (this && this.notifier && this.notifier.close) {
                    this.notifier.close();
                    this.notifier = null;
                }
            }.bind(this);
            if (notifierLE && notifierLE.showConfirm) {
                this.notifier = notifierLE.showConfirm({
                    title: errorContent.title,
                    content: errorContent.message,
                    objectAction: { callback: callback, text: this.translate('ok')},
                    removeMiddleButton: true,
                    removeAditionalButton: true
                });
            }
        }

    };

    FileSharingViewController.prototype.updateClientProperties = function() {
        // Do this with a timeout - so that if it changes rapidly we can avoid blinking
        var update = _updateClientProperties.bind(this);
        setTimeout(update, 500);

        function _updateClientProperties() {
            var canReceive = !!lpTag.WebAgent.logicController.canConsumerReceiveFileFromLocalFileSystem(this.chatId);
            var hasFileUploader = !!this.fileUploader;
            if (hasFileUploader !== canReceive) {
                _updateFileInput.call(this);
            }
        }
    };

    function _bindChatEvents() {
        this.bindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.features', callback: this.updateClientProperties});
        this.bindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.integration', callback: this.updateClientProperties});
    }

    function _unbindChatEvents() {
        this.unbindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.features', callback: this.updateClientProperties});
        this.unbindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.integration', callback: this.updateClientProperties});
    }

    function _getErrorContent(data) {
        if (!data || !data.newValue || !data.newValue.eventData || !data.newValue.eventData.errorType) {
            return null;
        }
        var errorTypes = lpTag.WebAgent.amsFileSharingController.getFileUploadErrorTypes();
        if (!errorTypes) {
            return null;
        }
        switch (data.newValue.eventData.errorType) {
            case errorTypes.TYPE:
                return {message: this.translateObj('fileSharing.error.fileType', [
                    {isTranslate: false, key: data.newValue.eventData.fileType || this.translate('fileSharing.unknown_file')}, {isTranslate: false, key: _getAllowedExtensions()}]),
                    title: this.translate('fileSharing.errorTitle.fileType')};
            case errorTypes.SIZE:
                return {message: this.translateObj('fileSharing.error.fileSize', [lpTag.WebAgent.amsFileSharingController.getFileUploadSizeLimit()]),
                    title: this.translate('fileSharing.errorTitle.fileSize')};
        }
        return null;
    }

    function _getAllowedExtensions() {
        return '.' + lpTag.WebAgent.amsFileSharingController.getValidFileExtensions().map(function (extension) {
            return extension.toLowerCase();
        }).join(', .');
    }

    function _updateFileInput() {
        var button = this.getFirstElement(this.LPViewMap.BUTTON);
        if (lpTag.WebAgent.logicController.canConsumerReceiveFileFromLocalFileSystem(this.chatId)) {
            var wrapper = this.getFirstElement(this.LPViewMap.WRAPPER);
            var input = document.createElement('input');
            input.id = this.LPViewMap.INPUT_PREFIX + this.visitorId;
            input.type = 'file';
            input.setAttribute('accept', _getAllowedExtensions.call(this));
            input.setAttribute('class', 'lpview_agent_file_input agent_file_input');
            input.onchange = _onFileSelected.bind(this);
            wrapper.appendChild(input);
            this.fileUploader = input;
            this.removeClass(button, 'disabled');
            button.setAttribute('title', this.translate('fileSharing.tooltip.send'));
        } else {
            this.addClass(button, 'disabled');
            button.setAttribute('title', this.translate('fileSharing.tooltip.disabled'));
            this.fileUploader = null;
            delete this.fileUploader;
        }
    }

    function _onFileSelected(e) {
        if (e && e.target && e.target.files && e.target.files.length > 0) {
            var currentFile = e.target.files[0];
            this.modelController.onFileSelected({file: currentFile, visitorId: this.visitorId, chat: this.chatId});
            if (this.fileUploader) {
                this.fileUploader.value = '';
            }
            currentFile = null;
        } else {
            this.logger.warn('Could not load file. Error:' + JSON.stringify(e));
        }
    }

    return FileSharingViewController;

});
